import { useContext, useEffect, useState } from "react";
import "../../../assets/css/outbound.css";
import "../../../assets/css/phonePage.css";
import { AppContext } from "../../../context/AppContext";
import useHttp from "../../../hooks/useHttp";
import HNotification from "../../../components/custom/notification/HNotification";
import NoticeModal from "./NoticeModal";
import { Select } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import editIcon from "../../../assets/icons/editIcon.svg";
import { Space } from "antd";

function EditMessageServiceId({ msgSidList, messageServiceId, friendlyName, phoneNumber, integId }) {
    const [hover, setHover] = useState(false);
    const [showSelect, setShowSelect] = useState(false);
    const [getMsgValue, setMsgValue] = useState(messageServiceId);
    const [messageServiceValue, setMessageServiceValue] = useState(null);
    const [showNotice, setShowNotice] = useState(false);
    const [finalMessageServiceId, setFinalMessageServiceId] = useState(null);
    const [msgSidLists, setMsgSidLists] = useState([]);
    const [appProperties] = useContext(AppContext);
  
    const { fetchData } = useHttp();
  
    useEffect(() => {
      if (msgSidList?.length < 1) {
        fetchData(`omessage/${integId}/numbers`, "GET", null, appProperties)
          .then((response) => {
            const responseData = JSON.parse(response);
            if (responseData?.data?.messagingServices) {
              let getMsgServicesLists = responseData.data.messagingServices;
              const msgSidsList = getMsgServicesLists.map((service) => ({
                friendlyName: service.friendlyName,
                sid: service.sid,
              }));
              setMsgSidLists(msgSidsList);
            }
          })
          .catch((err) => {});
      } else {
        setMsgSidLists(msgSidList);
      }
    }, [appProperties, fetchData, integId, msgSidList]);
  
    function handleServiceChange(value) {
      setMessageServiceValue(value);
    }
    function handleMsgService() {
      if (messageServiceValue === getMsgValue || messageServiceValue === finalMessageServiceId) {
        setHover(false);
        setShowSelect(false);
      } else if (messageServiceValue !== "") {
        setShowNotice(true);
      }
    }
  
    function editModalConfirm() {
      setShowNotice(false);
  
      const appData = {
        phoneNumber: phoneNumber,
        messageServiceId: getMsgValue,
        friendlyName: friendlyName,
      };
      fetchData(
        "omessage/" + integId + "/updatePhone?associatedSid=" + messageServiceValue,
        "PUT",
        appData,
        appProperties
      ).then(function (response) {
        response = JSON.parse(response);
        if (response.data.data !== undefined) {
          setFinalMessageServiceId(response.data.data.messageServiceId);
          setMsgValue(response.data.data.messageServiceId);
          setShowSelect(false);
          setHover(false);
        }
        if (response.data.errorMessage !== undefined) {
          setFinalMessageServiceId(messageServiceId);
          HNotification.notify({ type: "error", message: "Error", description: response.data.errorMessage });
          setShowSelect(false);
          setHover(false);
        }
      });
    }
    return (
      <>
        {hover === true ? (
          <>
            {showSelect === false ? (
              <div
                onMouseOut={() => {
                  setHover(false);
                }}
                onClick={() => {
                  setShowSelect(true);
                }}
              >
                <img
                  src={editIcon}
                  alt="editIcon"
                  style={{
                    height: "20px",
                    width: "20px",
                    cursor: "pointer",
                  }}
                />
              </div>
            ) : (
              <>
                <div>
                  <Space>
                    <Select
                      className="hs-bg-off-white focus-border w-100"
                      suffixIcon={<div className="actionIconsSprite fromNumberDropDownIcon" />}
                      variant="borderless"
                      style={{ width: "10rem" }}
                      placeholder="choose Messaging Service"
                      onSelect={handleServiceChange}
                      // onMouseOut={()=>{setHover(false)}}
                    >
                      {msgSidLists?.map((value, index) => (
                        <Select.Option key={index} value={value.sid}>
                          {value.friendlyName + "(" + value.sid + ")"}
                        </Select.Option>
                      ))}
                    </Select>
                    <NoticeModal
                      show={showNotice}
                      cancel={() => {
                        setShowNotice(false);
                      }}
                      handleModalCancel={() => {
                        setShowNotice(false);
                      }}
                      handleModalConfirm={editModalConfirm}
                    />
                    <CheckCircleOutlined className="checkMsgIcon" onClick={handleMsgService} />
                    <CloseCircleOutlined
                      className="closeMsgIcon"
                      onClick={() => {
                        setShowSelect(false);
                      }}
                    />
                  </Space>
                </div>
              </>
            )}
          </>
        ) : (
          <div
            onMouseOver={() => {
              setHover(true);
            }}
            onMouseOut={() => {
              setHover(false);
            }}
          >
            {finalMessageServiceId || messageServiceId}
          </div>
        )}
      </>
    );
}

export default EditMessageServiceId;